export const createTree = (dataset, parentKey = 'parentId', addNotFoundToRoot = true) => {
	const hashTable = Object.create(null);

	dataset.forEach(aData => hashTable[aData.id] = { ...aData, children: [] });
	const dataTree = [];

	dataset.forEach(aData => {
		if (typeof aData[parentKey] === 'number') {
			if (aData[parentKey] in hashTable) {
				hashTable[aData[parentKey]].children.push(hashTable[aData.id]);
			} else {
				if (addNotFoundToRoot) {
					dataTree.push(hashTable[aData.id]);
				}
			}
		} else {
			dataTree.push(hashTable[aData.id]);
		}
	});

	return dataTree;
};

export const toFlat = (tree) => {

	let flatArray = [];

	function flatten(node) {
		flatArray.push(node);

		if (node.children && node.children.length > 0) {
			for (let i = 0; i < node.children.length; i++) {
				flatten(node.children[i]);
			}
		}
	}

	for (let i = 0; i < tree.length; i++) {
		flatten(tree[i]);
	}

	return flatArray;
};

export const getPathIds = (tree, targetId) => {
	let pathIds = [];

	const traverse = (node, path) => {
		path.push(node.id);

		if (node.id === targetId) {
			pathIds = path.slice();
		} else {
			for (let i = 0; i < node.children.length; i++) {
				traverse(node.children[i], path);
			}
		}

		path.pop();
	};

	for (let i = 0; i < tree.length; i++) {
		traverse(tree[i], []);
	}

	return pathIds;
};


export const findById = (tree, id) => {
	for (const item of tree) {
		if (item.id === id) {
			return item;
		}

		if (item.children && item.children.length > 0) {
			const foundObject = findById(item.children, id);

			if (foundObject) {
				return foundObject;
			}
		}
	}

	return null;
};
